import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';

import { AssistantService } from '@core/services/assistant/assistant.service';
import { ICONS } from '@core/services/icons/icons.service';
import { escapeHtml } from '@core/utils/html-escape.utils';

import { TooltipComponent } from '@shared/components/tooltip/tooltip.component';

import {
  AssistantContextTextComponent,
  CONTEXT_ICONS,
  contextLabel
} from './assistant-context-text.component';

@Component({
  selector: 'app-assistant-context-line',
  imports: [TranslatePipe, TooltipComponent, AssistantContextTextComponent],
  templateUrl: './assistant-context-line.component.html',
  styles: ``
})
export class AssistantContextLineComponent {
  protected readonly assistant = inject(AssistantService);
  private readonly translate = inject(TranslateService);
  private readonly lang = toSignal(this.translate.onLangChange.pipe(map((e) => e.lang)), {
    initialValue: this.translate.getCurrentLang()
  });
  protected readonly ICONS = ICONS;
  protected readonly icons = CONTEXT_ICONS;

  protected readonly details = computed(() => {
    this.lang();
    const summary = this.assistant.contextSummary();
    const context = this.assistant.pageContext();
    if (!summary || !context) return { label: '', html: '' };
    const t = (key: string) => this.translate.instant(key);
    const none = t('assistant.context.none');
    const rows: [string, string][] = [
      [t('assistant.context.page'), contextLabel(summary, this.translate)],
      [t('assistant.context.search'), context.view?.search || none],
      [
        t('assistant.context.filters'),
        context.view?.filters !== undefined ? t('assistant.context.filters_on') : none
      ]
    ];
    return {
      label: `${t('assistant.context.tooltip_title')}. ${rows.map(([k, v]) => `${k}: ${v}`).join('. ')}`,
      html: rows
        .map(
          ([k, v]) =>
            `<div><span class="opacity-70">${escapeHtml(k)}</span> ${escapeHtml(v)}</div>`
        )
        .join('')
    };
  });
}
